const { GlobalProvider } = require('./src/context');

exports.wrapRootElement = GlobalProvider;
